import { render, staticRenderFns } from "./IconJsk.vue?vue&type=template&id=09116c5e"
import script from "./IconJsk.vue?vue&type=script&lang=js"
export * from "./IconJsk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports